(function() {
    'use strict';
    angular
        .module('c3WebApp')
        .factory('SupervisorCount', SupervisorCount)
        .factory('SignRoleCount', SignRoleCount);

    SupervisorCount.$inject = ['$resource'];
    SignRoleCount.$inject = ['$resource'];

    function SupervisorCount ($resource) {
        var resourceUrl =  'api/certificate-request-batches/supervisor/count/';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return {
                    	data: data
                    };
                }
            }
        });
    }
    
    function SignRoleCount ($resource) {
        var resourceUrl =  'api/certificate-request-batches/signrole/count/';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return {
                    	data: data
                    };
                }
            }
        });
    }
})();
